<template>
  <div class="feedback-list">
    <el-card>
      <template slot="header">
        <div class="card-header">
          <span>意见反馈管理</span>
        </div>
      </template>
      <el-table :data="feedbackList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="user_id" label="用户ID" width="120" />
        <el-table-column prop="content" label="反馈内容" />
        <el-table-column prop="contact" label="联系方式" width="150" />
        <el-table-column prop="created_at" label="提交时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="handleView(scope.row.id)">查看</el-button>
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>

    <!-- 反馈详情对话框 -->
    <el-dialog :visible.sync="detailDialogVisible" title="反馈详情" width="600px">
      <el-form :model="feedbackDetail" label-width="100px">
        <el-form-item label="用户ID">
          <el-input v-model="feedbackDetail.user_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="反馈内容">
          <el-input v-model="feedbackDetail.content" type="textarea" rows="4" disabled></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="feedbackDetail.contact" disabled></el-input>
        </el-form-item>
        <el-form-item label="提交时间">
          <el-input v-model="feedbackDetail.created_at" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'FeedbackList',
  data() {
    return {
      feedbackList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      detailDialogVisible: false,
      feedbackDetail: {}
    }
  },
  mounted() {
    this.fetchFeedbackList()
  },
  methods: {
    fetchFeedbackList() {
      const token = localStorage.getItem('adminToken')
      fetch(`/api/admin/feedback/list?page=${this.currentPage}&pageSize=${this.pageSize}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          this.feedbackList = data.data.list
          this.total = data.data.total
        }
      })
      .catch(() => {
        this.$message.error('获取反馈列表失败')
      })
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchFeedbackList()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchFeedbackList()
    },
    handleView(id) {
      const token = localStorage.getItem('adminToken')
      fetch(`/api/admin/feedback/detail/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          this.feedbackDetail = data.data
          this.detailDialogVisible = true
        }
      })
      .catch(() => {
        this.$message.error('获取反馈详情失败')
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除这条反馈吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const token = localStorage.getItem('adminToken')
        fetch(`/api/admin/feedback/delete/${id}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.$message.success('删除成功')
            this.fetchFeedbackList()
          } else {
            this.$message.error(data.message || '删除失败')
          }
        })
        .catch(() => {
          this.$message.error('删除失败')
        })
      })
      .catch(() => {})
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.feedback-list {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>